import tw, { styled } from 'twin.macro';

const Heading3 = styled.h3`
  ${tw`text-xl md:text-2xl leading-10 font-bold`};
  ${tw`print:!text-base`}
  line-height: 1.333;
`;

export default Heading3;
